export default __webpack_public_path__ + "static/media/Brow_4_C4.e66540eb.svg";